import { RouteObject } from "react-router-dom";
import { IconSettings } from "@tabler/icons-react";
import { routeCan } from "src/authentication/routeCan";
import { Action } from "src/casl/Action";

export const settingsRoutes: RouteObject[] = [
    {
        handle: { crumb: "Settings", icon: IconSettings, ...routeCan(Action.Manage, "all") },

        children: [
            { index: true, lazy: () => import("./SettingsIndexScreen") },

            {
                path: "church",
                handle: { crumb: "Church" },
                children: [{ index: true, lazy: () => import("./church/ChurchSettingsScreen") }],
            },

            {
                path: "profile-tasks",
                handle: { crumb: "Profile tasks" },
                children: [{ index: true, lazy: () => import("./profile-tasks/ProfileTasksSettingsScreen") }],
            },

            {
                path: "clearances",
                handle: { crumb: "Child protection" },
                children: [{ index: true, lazy: () => import("./child-protection/ChildProtectionSettingsScreen") }],
            },

            {
                path: "email",
                handle: { crumb: "Email" },
                children: [{ index: true, lazy: () => import("./email/EmailSettingsScreen") }],
            },

            {
                path: "users",
                handle: { crumb: "Users" },
                children: [{ index: true, lazy: () => import("./users/UsersScreen") }],
            },

            {
                path: "rota-changes",
                handle: { crumb: "Rota changes" },
                children: [{ index: true, lazy: () => import("./rota-changes/RotaChangeAuditScreen") }],
            },

            {
                path: "ministries-admin",
                handle: { crumb: "Ministries admin" },
                children: [
                    {
                        index: true,
                        lazy: () => import("./ministries/MinistriesAdminScreen"),
                    },
                ],
            },

            {
                path: "calendar-events",
                handle: { crumb: "Calendar event resources" },
                children: [{ index: true, element: <div>🚧 Calendar Events</div> }],
            },

            {
                path: "vehicles",
                handle: { crumb: "Vehicles" },
                children: [
                    { index: true, lazy: () => import("./vehicles/VehiclesScreen") },

                    {
                        path: ":vehicleId",
                        lazy: () => import("./vehicles/view-vehicle/VehicleLayout"),
                        children: [
                            { index: true, lazy: () => import("./vehicles/view-vehicle/VehicleDetailsTab") },
                            { path: "runs", lazy: () => import("./vehicles/view-vehicle/VehicleRunsTab") },
                        ],
                    },
                ],
            },
        ],
    },
];
